import { Button } from "antd";
import className from "classnames";
import React from "react";
import { downloadState, ZipPaperListItem } from "service/exam";
import style from "./index.module.scss";

interface ListItemProps {
    data: ZipPaperListItem;
    packageName: string;
}

export default function ListItem({ data, packageName }: ListItemProps) {
    const handleDownload = () => {
        window.open(data.url);
    };

    return (
        <div className={style.root}>
            <div className={style.left}>
                <img src={require("./img/icon.png")} />
                <div className={style.fileName}>
                    {data.fileName ? data.fileName : packageName}
                </div>
            </div>

            <div className={style.right}>
                {data.statusCode !== downloadState.success && (
                    <div className={style.loading}>
                        正在处理中，请耐心等待～
                    </div>
                )}
                <Button
                    className={className(style.btn)}
                    disabled={data.statusCode !== downloadState.success}
                    onClick={handleDownload}>
                    下载
                </Button>
            </div>
        </div>
    );
}
